/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useState, useContext, useEffect } from "react";
import AppContext from "../../../../Store/AppContext";
import { ImportarLeads } from "../../../../Services/Lead";
import { DownloadTemplate } from "../../../../Services/Download";
import { validarPermissoesPagina } from "../../../../Utils/validarPermissoesPagina";

const tituloTela = "Importar Lead";
export const ImportarLeadContext = createContext();

function initialState() {
  return {
    arquivo: null,
    resultadosImportacao: [],
    totalLeadsImportados: 0,
    totalLeadsComSucesso: 0,
    totalLeadsComErro: 0,
    permissoesPagina: null,
  };
}

const ImportarArquivo = async (arquivo) => {
  const result = await ImportarLeads(arquivo);
  return result;
};

const ImportarLeadProvider = ({ children }) => {
  const { showLoading, hideLoading, showMessage, setTituloTela } = useContext(
    AppContext
  );
  const [values, setValues] = useState(initialState());

  useEffect(() => {
    showLoading();
    async function carregarDependencias() {
      const permissoesPagina = await validarPermissoesPagina();
      
      setValues({
        ...values,
        permissoesPagina: permissoesPagina,
      });
      hideLoading();
      setTituloTela(tituloTela);
    }

    carregarDependencias();
  }, []);

  async function importar() {
    showLoading();

    if (!values.arquivo) {
      showMessage("Erro", "Arquivo não Informado.");
      hideLoading();
      return;
    }

    const result = await ImportarArquivo(values.arquivo);

    if (result.success) {
      const resultadosImportacao = result.resultadosImportacao;

      const totalLeadsImportados = result.resultadosImportacao.length;

      const totalLeadsComSucesso = result.resultadosImportacao.filter(
        (resultadoImportacao) => resultadoImportacao.sucesso
      ).length;

      const totalLeadsComErro = result.resultadosImportacao.filter(
        (resultadoImportacao) => !resultadoImportacao.sucesso
      ).length;

      setValues({
        ...values,
        resultadosImportacao: resultadosImportacao,
        totalLeadsImportados: totalLeadsImportados,
        totalLeadsComSucesso: totalLeadsComSucesso,
        totalLeadsComErro: totalLeadsComErro,
      });

      showMessage("Sucesso", "Operação Realizada com Sucesso.");
    } else {
      showMessage("Erro", "Erro durante a gravação do Lead.");
      result.errors.map((erro) => showMessage("Erro", erro.errorMessage));
    }

    hideLoading();
  }
  const downloadTemplate = async () => {
    const result = await DownloadTemplate("Lead.xlsx");
    return result;
  };
  return (
    <ImportarLeadContext.Provider
      value={{
        values,
        setValues,
        importar,
        downloadTemplate,
      }}
    >
      {children}
    </ImportarLeadContext.Provider>
  );
};

export default ImportarLeadProvider;
